<!-- Header Section - consistent across all steps -->
<div class="icon-container" *ngIf="userStep() !== 'input-otp'">
  <img src="assets/icon/input-pin.svg" alt="PIN Icon" class="pin-icon" />
</div>
<div class="p-card-title" *ngIf="userStep() !== 'input-otp'">{{ headerMap[userStep()] }}</div>
<div class="p-card-subtitle" *ngIf="userStep() !== 'input-otp'">
  {{ subTitle() }}
</div>

<!-- Multi-step Content -->
<div [ngSwitch]="userStep()">
  <!-- Step 1: OTP Verification -->
  <div *ngSwitchCase="'input-otp'" class="otp-step">
    <app-otp
      mode="inline"
      [countDownStarted]="countDownStarted"
      [resendDelaySeconds]="resendDelaySeconds()"
      [twoFactorAuthMethod]="twoFactorAuthMethod()"
      event="reset-pin"
      (isOtpComplete)="onOtpComplete($event)"
    >
    </app-otp>
  </div>

  <!-- Step 2: Create New PIN -->
  <div *ngSwitchCase="'create-pin'">
    <div>
      <code-input
        #codeInput
        class="pin-input"
        [isCodeHidden]="true"
        [codeLength]="6"
        [isCharsCode]="false"
        (codeChanged)="onCodeChanged($event)"
        [ngClass]="{
          'invalid shake': error$(),
        }"
      >
      </code-input>

      <p class="warning-message" *ngIf="error$()">
        <span>{{ error$() }}</span>
      </p>
    </div>

    <div class="button-group">
      <div class="action-buttons">
        <lib-button (click)="cancel()" label="Cancel" type="Secondary" width="120px"></lib-button>
        <lib-button
          (click)="next()"
          width="120px"
          label="Next"
          type="Primary"
          [disabled]="!pinValue || pinValue.length !== 6"
        ></lib-button>
      </div>
    </div>
  </div>

  <!-- Step 3: Confirm New PIN -->
  <div *ngSwitchCase="'confirm-pin'">
    <div>
      <code-input
        #codeInput
        class="pin-input"
        [isCodeHidden]="true"
        [codeLength]="6"
        [isCharsCode]="false"
        (codeChanged)="onCodeChanged($event)"
        [ngClass]="{
          'invalid shake': error$(),
        }"
      >
      </code-input>

      <p class="warning-message" *ngIf="error$()">
        <span>{{ error$() }}</span>
      </p>
    </div>

    <div class="button-group">
      <div class="action-buttons">
        <lib-button (click)="cancel()" label="Cancel" type="Secondary" width="120px"></lib-button>
        <lib-button
          (click)="next()"
          width="120px"
          label="Next"
          type="Primary"
          [disabled]="!pinValue || pinValue.length !== 6"
        ></lib-button>
      </div>
    </div>
  </div>

  <!-- Step 4: Success -->
  <div *ngSwitchCase="'done'">
    <div class="success-content">
      <div class="button-group">
        <lib-button type="Primary" label="Close" width="50%" (click)="closeDialog()"> </lib-button>
      </div>
    </div>
  </div>
</div>

<app-block-loading [show]="isLoading()"></app-block-loading>
